export const FIELD_DATA_TYPES = [
  'Text',
  'Number',
  'NumberRange',
  'Boolean',
  'Date',
  'Dropdown',
  'MultiSelect',
] as const;

export type CustomFieldDataType = (typeof FIELD_DATA_TYPES)[number];

export const REST_ATTRIBUTE_TYPES = ['string', 'number', 'boolean', 'date', 'enum', 'multienum'] as const;

/** Types whose definition declares `enumOptions`. */
export const OPTION_ATTRIBUTE_TYPES: readonly RestAttributeType[] = ['enum', 'multienum'];

export const RANGE_ATTRIBUTE_TYPES: readonly RestAttributeType[] = ['number', 'date'];

export type RestAttributeType = (typeof REST_ATTRIBUTE_TYPES)[number];

export type CustomFieldDefinition = {
  ItemId: string;
  Label?: string | null;
  Key?: string | null;
  Category?: string | null;
  DataType?: string | null;
  Options?: string[] | null;
  IsFilterable?: boolean | null;
  IsDefault?: boolean | null;
  isDeleted?: boolean | null;
  CreatedDate?: string | null;
  LastUpdatedDate?: string | null;
  Required?: boolean | null;
  UsageCount?: number | null;
  RestType?: RestAttributeType | null;
  IsRangeFilterable?: boolean | null;
};

export type CustomFieldDefinitionFilterInput = {
  and?: CustomFieldDefinitionFilterInput[];
  or?: CustomFieldDefinitionFilterInput[];
  ItemId?: { eq?: string; in?: string[] };
  Key?: { eq?: string; contains?: string };
  isDeleted?: { eq?: boolean };
  IsDefault?: { eq?: boolean };
};

export type CustomFieldDefinitionSortInput = {
  field: string;
  direction?: 'ASC' | 'DESC';
};

export type CustomFieldDefinitionsPagingResult = {
  items: CustomFieldDefinition[];
  totalCount: number;
  pageNo: number;
  pageSize: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type GetCustomFieldDefinitionsParams = {
  where?: CustomFieldDefinitionFilterInput;
  order?: CustomFieldDefinitionSortInput[];
  paging?: {
    pageNo?: number;
    pageSize?: number;
  };
};

export type CustomFieldDefinitionInsertInput = {
  Label: string;
  Key: string;
  Category: string;
  DataType: CustomFieldDataType;
  Options?: string[];
  IsFilterable?: boolean;
  IsDefault?: boolean;
  isDeleted?: boolean;
};

export type CustomFieldDefinitionUpdateInput = Partial<
  Omit<CustomFieldDefinitionInsertInput, 'Key' | 'DataType'>
>;

export type InsertCustomFieldDefinitionResult = {
  acknowledged: boolean;
  itemId: string;
  totalImpactedData: number;
  message?: string | null;
};

export type UpdateCustomFieldDefinitionResult = InsertCustomFieldDefinitionResult;
